import './App.css';
import './theme/style.css';
import { useMemo } from "react";
import BuildTheme from "./theme";
import store from "./store";
import Login from "./pages/Login";
import { routes } from "./routes/PrivateRoute";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material";
import AppLayout from "./layouts/AppLayout";
import AuthLayout from "./layouts/AuthLayout";
import { GetItem } from "./utils/storage";
import { StorageKey } from "./constants/constants";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const token = GetItem(StorageKey.TOKEN);

  return token ? (
    <Component {...rest} />
  ) : (
    <Navigate to="/" replace />
  );
};

const PrivateRoutes = () => {
  return routes.map(({ component: Component, ...props }, i) => (
    <Route
      key={i}
      {...props}
      element={<PrivateRoute component={Component} />}
    />
  ));
};

function App() {
  const theme = useMemo(() => BuildTheme('light'), []);

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<AuthLayout />}>
              <Route path="/" element={<Login />} />
            </Route>
            <Route path="/app" element={<AppLayout />}>
              {PrivateRoutes()}
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
